import React, { useState, useEffect } from 'react';
import 'dayjs/locale/sv';
import * as request from "../../services/FetchService";
import { useTranslation } from "react-i18next";
import Button from '../Buttons/Button';
import { useContextData } from '../ContextData';

const SharedMessage = (props) => {
    const [message, setMessage] = useState()
    const { t } = useTranslation();
	const { setDeviceListCompact } = useContextData();

    useEffect(() => {
        setMessage(props.message)
    }, [props])

	const getDevices = async() => {
        try {
            const { data } = await request.get("devices/list");

            if (data?.errorCode === "10003" || data?.errorCode === "10002") {
                localStorage.clear();
                window.location.href = "login";
                return;
            }
            // 2️⃣  Make sure we always store a *real array* (fallback to [])
            const list = Array.isArray(data?.devices) ? data.devices : [];
            setDeviceListCompact(list);
        } finally {
            //setLoading(false);
        }
	};

    const handleInvite = (accept, id) => {
        request.post("", "device/share/acceptdenyinvitation", {deviceid: [id], accept: accept}).then((response) => {
            if(response.data.successful){
                getDevices()
                props.refreshList()
            }else{
                alert("error")
            }
        })
    }

    if(message){
        return(
            <div className="p-3 d-flex flex-column justify-content-center h-100 w-75 mx-auto">
                <img className="w-100 mx-auto modelphoto mb-5" src={message.image} alt="" />
                <p>{message ? message?.content : t("inapp.share_device_body", {from: message.sharedfrom, device: message.devicename})}</p>
                <div className="d-flex justify-content-between mt-3">
                    <Button onClick={() => handleInvite(true, message.deviceid)} btnClass={`btn-primary gradient-button-primary w-100 mt-auto`}>{t("inapp.accept")}</Button>
                    <Button btnClass="btn-danger w-100 ms-2" onClick={() => handleInvite(false, message.deviceid)}>{t("inapp.decline")}</Button>
                </div>
            </div>
        )
    }

}

export default SharedMessage;